module.exports = __webpack_public_path__ + "img/Gemnote_logo_text_horizontal.72f99f1e.svg";